import React from 'react';
import styles from '../../styles/Pagination.module.css'
import Link from 'next/link'

const Pagination = (props) => {
    const arr = Array.from({length: props.pagesCount}, (x, i) => i + 1);
    return (
        <div className={styles.pagination}>
        {/* Left navigation arrow */}
        
        { props.currentPage > 1 ? 
            <Link href={`/blog/${props.tag_slug}/${parseInt(props.currentPage) - 1}`} >
                <a
                // className={`prev ${props.currentPage === 1 ? styles.disabled : ''}`}
                >Previous</a>
            </Link>
        
            :
            <span // should be disabled prev button
            // className={`prev ${props.currentPage === 1 ? styles.disabled : ''}`}
            >Previous</span>
            
            }
        

        {arr.map((pageNumber, index) => (
            
            <Link key={pageNumber} href={index === 0 ? `/blog/${props.tag_slug}` : `/blog/${props.tag_slug}/${pageNumber}`} > 
            <a  //disbale button on current page
            //   className={`${props.currentPage === pageNumber ? styles.active : null}`}
            >
                {pageNumber}
            </a>
            </Link>
    
        ))}
        {/*  Right Navigation arrow */}
   
        { props.currentPage !== parseInt(props.pagesCount) ? 
            <Link href={`/blog/${props.tag_slug}/${parseInt(props.currentPage) + 1}`} >
                    <a
            // className={`prev ${props.currentPage === 1 ? styles.disabled : ''}`}
            >Next</a>
            </Link>
        
            :
            <span> 
            {/* // should be disabled next button
            // className={`prev ${props.currentPage === 1 ? styles.disabled : ''}`} */}
            Next</span>
            
            }

    </div>
    );
    };

export default Pagination;